export const TEST_NAME='2020_Q1_B&S_CROSS_PROMOTE';
export const HEAP_CROSS_PROMOTE_EXPERIMENT_NAME = 'Experiment: Cross Promote B&S 2020 Q1';
